import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
import { SortablejsModule } from 'angular-sortablejs';
import { SharedModule } from 'app/components/shared.module';
import { SlideshowWidget, SlideshowWidgetComponent } from 'app/views/presentations/widgets/slideshow/slideshow.widget';
import { WidgetWrapperModule } from './../widgetWrapper.module';

@NgModule({
    imports: [
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        BrowserModule,
        SharedModule,
        SortablejsModule.forRoot({ animation: 150 }),
        WidgetWrapperModule.wrapWidget(SlideshowWidget)
    ],
    declarations: [
        SlideshowWidgetComponent
    ],
    entryComponents: [
        SlideshowWidgetComponent
    ],
    providers: [
    ]
})
export class SlideshowWidgetModule { }


// WEBPACK FOOTER //
// ./src/app/views/presentations/widgets/slideshow/slideshow.module.ts